import { useState, useEffect } from "react";

export function useStickyState(key, initial) {
  const [value, setValue] = useState(() => {
    const raw = localStorage.getItem(key);
    try {
      return raw ? JSON.parse(raw) : initial;
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}
